import { buildMeetingsBucketDemoRow, emptyMeetingLoadBucket, generateMeetingsBucketMockRaw, sharePercent } from '@web/lib/demo/utils/meetingsBucketDemoUtils';
import { emptyMeetingsByWhenRawCounts, MEETINGS_BY_WHEN_KEYS } from '@workalizer/shared';
export var meetingsByWhenAnalytic = function (input) {
    var includeTeamMetrics = input.userId == null;
    var current = emptyMeetingsByWhenRawCounts();
    var previous = emptyMeetingsByWhenRawCounts();
    for (var _i = 0, MEETINGS_BY_WHEN_KEYS_1 = MEETINGS_BY_WHEN_KEYS; _i < MEETINGS_BY_WHEN_KEYS_1.length; _i++) {
        var key = MEETINGS_BY_WHEN_KEYS_1[_i];
        current[key] = generateMeetingsBucketMockRaw();
        previous[key] = generateMeetingsBucketMockRaw();
    }
    // Keep early/late as subsets of work-hours for demo realism.
    current.earlyMorning.meetingCount = Math.min(current.earlyMorning.meetingCount, current.workHours.meetingCount);
    current.lateEvening.meetingCount = Math.min(current.lateEvening.meetingCount, Math.max(0, current.workHours.meetingCount - current.earlyMorning.meetingCount));
    previous.earlyMorning.meetingCount = Math.min(previous.earlyMorning.meetingCount, previous.workHours.meetingCount);
    previous.lateEvening.meetingCount = Math.min(previous.lateEvening.meetingCount, Math.max(0, previous.workHours.meetingCount - previous.earlyMorning.meetingCount));
    var currentTotal = current.workHours.meetingCount + current.afterHours.meetingCount;
    var previousTotal = previous.workHours.meetingCount + previous.afterHours.meetingCount;
    return {
        rows: MEETINGS_BY_WHEN_KEYS.map(function (key) {
            var _a, _b;
            var curr = (_a = current[key]) !== null && _a !== void 0 ? _a : emptyMeetingLoadBucket();
            var prev = (_b = previous[key]) !== null && _b !== void 0 ? _b : emptyMeetingLoadBucket();
            return buildMeetingsBucketDemoRow(key, curr, prev, sharePercent(curr.meetingCount, currentTotal), sharePercent(prev.meetingCount, previousTotal), includeTeamMetrics);
        })
    };
};
